import React, { useState, useEffect } from "react";

export const Box = () => {

    const [imageUrl, setImageUrl] = useState("");
    const [inputText, setInputText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (imageUrl && !imageError && !showModal) {
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    handlePrevious();
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    handleNext();
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [imageUrl, imageError, showModal]);

    const handleSubmit = () => {
        if (inputText.trim()) {
            console.log(inputText);
            setIsLoading(true);
            setImageError(false);
            setImageUrl(inputText);
        }
    };

    const handleImageError = () => {
        setImageError(true);
        setIsLoading(false);
    };

    const handleImageLoad = () => {
        setIsLoading(false);
    };

    const handleDownload = async () => {
        if (!imageUrl) return;
        
        try {
            // const imageUrlFull = `https://erp.iiita.ac.in/uploads/iiita/photos/${imageUrl.toLowerCase()}`;
            const imageUrlFull = `https://erp.iiita.ac.in/uploads/iiita/photos/${imageUrl}`;
            console.log(imageUrlFull)
            console.log(imageUrlFull)
            console.log(imageUrlFull)
            const response = await fetch(imageUrlFull);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${imageUrl}.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    const incrementRollNumber = (rollNum) => {
        const match = rollNum.match(/^([a-zA-Z]+)(\d+)$/);
        if (match) {
            const prefix = match[1];
            const number = parseInt(match[2], 10);
            const paddedNumber = String(number + 1).padStart(match[2].length, '0');
            return prefix + paddedNumber;
        }
        return rollNum;
    };

    const decrementRollNumber = (rollNum) => {
        const match = rollNum.match(/^([a-zA-Z]+)(\d+)$/);
        if (match) {
            const prefix = match[1];
            const number = parseInt(match[2], 10);
            if (number > 1) {
                const paddedNumber = String(number - 1).padStart(match[2].length, '0');
                return prefix + paddedNumber;
            }
        }
        return rollNum;
    };

    const handlePrevious = () => {
        const newRollNum = decrementRollNumber(imageUrl);
        setIsLoading(true);
        setImageUrl(newRollNum);
        setInputText(newRollNum);
        setImageError(false);
    };

    const handleNext = () => {
        const newRollNum = incrementRollNumber(imageUrl);
        setIsLoading(true);
        setImageUrl(newRollNum);
        setInputText(newRollNum);
        setImageError(false);
    };

    return (
        <div className="student-lookup-container">
            <div className="lookup-card">
                <div className="card-header">
                    <h1 className="card-title">IIIT Allahabad</h1>
                    <p className="card-subtitle">Student Photo Lookup System</p>
                </div>
                
                <div className="search-section">
                    <div className="input-group">
                        <input 
                            type="text" 
                            className="search-input"
                            placeholder="Enter roll number (e.g., iit2022xxx)" 
                            value={inputText} 
                            onChange={(e) => setInputText(e.target.value)} 
                            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()} 
                        />
                        <button className="search-button" onClick={handleSubmit}>
                            <span className="button-text">Search</span>
                        </button>
                    </div>
                </div>

                <div className="image-section">
                    {!imageUrl && !imageError && !isLoading && (
                        <div className="placeholder">
                            <svg className="placeholder-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                            <p className="placeholder-text">Enter a roll number to view student photo</p>
                        </div>
                    )}
                    
                    {isLoading && (
                        <div className="loading-spinner">
                            <div className="spinner"></div>
                        </div>
                    )}
                    
                    {imageUrl && !imageError && (
                        <div className="image-wrapper" style={{ display: isLoading ? 'none' : 'block' }}>
                            <div className="image-container">
                                <button className="nav-arrow nav-arrow-left" onClick={handlePrevious} title="Previous student">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                <img 
                                    src={`https://erp.iiita.ac.in/uploads/iiita/photos/${imageUrl}`} 
                                    className="student-image" 
                                    alt="Student"
                                    onError={handleImageError}
                                    onLoad={handleImageLoad}
                                    onClick={() => setShowModal(true)}
                                />
                                <button className="nav-arrow nav-arrow-right" onClick={handleNext} title="Next student">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                            <div className="image-footer">
                                <p className="roll-number">Roll No: {imageUrl.toUpperCase()}</p>
                                <button className="download-button" onClick={handleDownload}>
                                    <svg className="download-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                    </svg>
                                    Download Photo
                                </button>
                            </div>
                        </div>
                    )}
                    
                    {imageError && (
                        <div className="error-message">
                            <svg className="error-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="error-text">Photo not found. Please check the roll number.</p>
                        </div>
                    )}
                </div>
                
                <div className="watermark">
                    Developed by Kushal Bansal
                </div>
            </div>

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={() => setShowModal(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <img 
                            src={`https://erp.iiita.ac.in/uploads/iiita/photos/${imageUrl}`} 
                            className="modal-image" 
                            alt="Student Full Size"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};